export default __webpack_public_path__ + "static/media/wrs_rts_eu.163bc935.png";